import { Button } from "@komplett/design-system";
import classNames from "classnames";
import React from "react";

import strings from "../../utils/strings";

interface FooterPropsI {
	continueShopping: () => void;
	goToCart: () => void;
	canCustomerDisablePopup?: boolean;
}

export const Footer = ({
	continueShopping,
	goToCart,
	canCustomerDisablePopup,
}: FooterPropsI) => {
	return (
		<footer
			className={classNames("addtocart-popup__footer", {
				"addtocart-popup__footer--can-customer-disable-popup":
					canCustomerDisablePopup,
			})}
		>
			<Button
				className="close-addtocart"
				variant="clear"
				size="lg"
				data-testid="footer-button-continue"
				onClick={continueShopping}
			>
				{strings.continueShopping}
			</Button>
            
			<Button
				className="goto-cart"
				variant="primary"
				size="lg"
				data-testid="footer-button-gotocart"
				onClick={goToCart}
			>
				{strings.goToCart}
			</Button>
		</footer>
	);
};
